import React, {Component} from 'react';
import axios from 'axios';
import './Address.css';

class Address extends React.Component {
    constructor(props){
        super(props);
        this.state = {
           
    }
    
      
}
  render() {
     
      
    
    return <div className="container ">
        <h3 className=" ml-2 address-titlt">Add New Address</h3>
       {/* <div className="mb-0">
                } <Map
                                google={this.props.google}
                                center={{lat: 18.5204, lng: 73.8567}}
                                height='180px'
                                zoom={15}
                    />
        </div>
        <div class="row mt-2">
        <div className="my-address" >
        <h5 className="locate mb-1 ">Your Location</h5> 
        <p className="new-product address pl-1"></p>
        </div>
        
        <button type="button" class="  ml-5  loc-btn">Locate<MyLocationIcon className="ml-2"/></button>
  </div>*/}
        {/* <form onSubmit={this.handleSubmit}> */}
        <div class="row-form mb-4">
            <input class="form-controls left-space " type="text" placeholder="House / Flat No" id="example-email-input"/>
        </div>
        <div class="row-form mb-4">
            <input class="form-controls left-space" type="text" placeholder="Address / Block" id="example-email-input"/>
        </div>
        <div class="row-form   center-space  ">
            <h7  class="green-label pl-1 "> Pincode</h7>
            <input class="form-controls " type="text" placeholder="" id="example-email-input"/>
        </div> 
        <div class="row-form   center-space  ">
            <h7  class="green-label pl-1 ">Landmark</h7>
            <input class="form-controls " type="text" placeholder="" id="example-email-input"/>
        </div>
        <div class="row-form   center-space  ">
            <h7  class="green-label pl-1 ">City</h7>
            <input class="form-controls " type="text" placeholder="" id="example-email-input"/>
        </div>
        <div class="row-form   center-space  d-none ">
        <h7  class="green-label pl-1 ">Country</h7>
            <input class="form-controls " type="text" placeholder="" defaultValue="India" id="example-email-input"/>
        </div>
        <div class="row-form   center-space d-none ">
            <h7  class="green-label pl-1 ">Latitude</h7>
            <input class="form-controls " type="text" placeholder="" id="example-email-input"/>
        </div>
        <div class="row-form   center-space  d-none ">
            <h7  class="green-label pl-1 ">Longitude</h7>
            <input class="form-controls " type="text" placeholder="" id="example-email-input"/>
        </div>
        <ul class="category-list my-inline-box"> 
            <li><div className="custom-control custom-checkbox ml-1">
                <input type="checkbox" name="Home" class="custom-control-input mr-3" id="defaultu" />
                    <label class="custom-control-label product-details mr-3 " for="defaultu">Home</label>
            </div></li>
            <li><div className="custom-control custom-checkbox">
                <input type="checkbox" name="Work" class="custom-control-input mr-3" id="defaultUnchecked-2"/>
                <label class="custom-control-label product-details mr-3" for="defaultUnchecked-2">Work</label>
            </div></li>
            <li><div className="custom-control custom-checkbox">
                <input type="checkbox" name="Other" class="custom-control-input mr-3" id="defaultUnchecked-3"/>
                <label class="custom-control-label product-details mr-3" for="defaultUnchecked-3">Other</label>
            </div></li>
        </ul>
        <div className="inline  mobi-sub2-btn mb-2 mt-3 com-itm-btn2 mob-nex-btn mob-nex-btn2 ">
        <button type="button" class="  btnn btn-hover btn-outline-success tag-btn  mob-can-btn mob-add-bk-btn ml-3">Back</button>

        <button type="button"  type="submit" class=" add-to-cart2 btnn tag-btn mb-2  mob-add-sub-btn ">Submit</button>
        
      </div>
     {/*  </form> */}
    </div>

        }
    }
    
    export default Address;